import * as S from './styles'

const NoData: React.FC = () => {
  return <S.Container>Não há registros para exibir</S.Container>
}

export default NoData
